import { MainImages } from '@lemon/assets';
import { ImageList } from '../../common/Image';

export const Creator = () => {
    return (
        <figure
            className="relative w-full h-full flex flex-col items-start text-left justify-center bg-white text-black
		  px-6 py-10 gap-5 md:px-16 md:py-20 md:gap-10 xl:px-32 xl:py-40"
        >
            <img src={MainImages.creator} alt="Customer" onDragStart={e => e.preventDefault()} />

            <h6 className="text-2xl font-bold text-left w-full">{title}</h6>
            <div className="flex flex-col gap-3 md:gap-4 text-[16px] md:text-[20px] lg:text-[24px] text-pretty leading-relaxed max-w-[1000px] w-full">
                <p>{description1}</p>
                <p>{description2}</p>
                <p>{description3}</p>
            </div>

            <ImageList images={images} />
        </figure>
    );
};

const title = '전문성과 영향력 확장';
const description1 = `뷰티 지식과 노하우를 콘텐츠로 공유하여 팔로워와 소통할 수 있습니다.`;
const description2 = `이를 통해 전문성을 바탕으로 영향력을 확대하고,`;
const description3 = `다양한 브랜드와의 협업 기회를 마련할 수 있습니다.`;
const images = [MainImages.creator_l, MainImages.creator_r];
